import React, { useContext, useEffect, useRef, useState } from "react";
import { BaseActivityProps } from "../Activity/Activity.component";
import { ActivityVideo } from "../../types";
import { observer } from "mobx-react";
import { StoreContext } from "../../context";
import {
  Container,
  RotateScreenContainer,
  RotateScreenIcon,
  RotateScreenMessage,
  VideoContainer,
  VideoTitleContainer,
} from "./ActivityVideo.style";
import { MediaContainer, StandardButton, Title } from "..";
import { isPortrait, useWindowSize } from "../../utils";

interface Props extends BaseActivityProps {
  activity: ActivityVideo;
}

const ActivityVideoContainer: React.FC<Props> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { core, store } = useContext(StoreContext);
  const texts = store.interfaceText;
  const [titleContainerHeight, setTitleContainerHeight] = useState(0);

  const onValidate = () => {
    if (props.goNext) props.goNext();
  };
  useEffect(() => {
    if (titleContainerHeight === 0) {
      setTitleContainerHeight(ref.current ? ref.current.offsetHeight : 0);
    }
  }, [ref]);

  if (props.activity.tracking?.successCondition === "open") {
    core.setInteractionResult(props.activity.id, "correct");
  }
  if (props.activity.tracking?.successCondition === "end") {
    //TODO: getVideo End
    core.setInteractionResult(props.activity.id, "correct");
  }
  // useWindowSize();
  return (
    <Container className="main-video-container">
      {props.activity.title && (
        <VideoTitleContainer ref={ref} className="video-title-container">
          <Title level={2}>{props.activity.title}</Title>
        </VideoTitleContainer>
      )}

      {!isPortrait() && (
        <VideoContainer titleHeight={titleContainerHeight} className="video-container">
          <MediaContainer media={props.activity.video} />{" "}
        </VideoContainer>
      )}
      {isPortrait() && (
        <RotateScreenContainer>
          <RotateScreenIcon />
          <RotateScreenMessage>{texts.rotateScreen}</RotateScreenMessage>
        </RotateScreenContainer>
      )}

      {props.goNext && (
        <StandardButton onClick={onValidate}>
          {props.nextBehaviour === "close" ? texts.close : texts.next}
        </StandardButton>
      )}
    </Container>
  );
};

export default observer(ActivityVideoContainer);
